import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus2",
  "use": "icon-plus2-usage",
  "viewBox": "0 0 824 824",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 824 824\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plus2\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M444 364V100h-80v264H60v80h304v304h80V444h304v-80z\" fill=\"#565D64\" p-id=\"1178\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plus2.svg
// module id = mFPN
// module chunks = 25